const vpsFree = state => state.features.vpsFree;
const vpsPaid = state => state.features.vpsPaid;
const monitoring = state => state.features.monitoring;

export default {
  vpsFree,
  vpsPaid,
  monitoring,
};
